import React, { Component } from 'react';

import { withFixedTitle } from 'src/components';

import Nightingale from 'src/charts/nightingale';

const SquishlessNightingale = withFixedTitle(Nightingale);

/* eslint-disable react/prop-types */

export default class FacetChart extends Component {
  constructor(props) {
    super(props);
    const { objects, selectedFacet, selectedFactor, selectedIndex, eventEmitter } = props;
    const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === selectedFacet);
    this.state = {
      selectedFactor,
      selectedFacet,
      selectedPxScore,
    };
    eventEmitter.subscribe('factorChanged', (code) => {
      this.setState({
        selectedFactor: code,
        selectedFacet: undefined,
      });
    });
    eventEmitter.subscribe('facetChanged', (code) => {
      this.setState({ selectedFacet: code });
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { selectedFacet, selectedPxScore: currentPxScore } = state;
    const { eventEmitter } = props;
    if (selectedFacet) {
      const { objects, selectedIndex } = props;
      const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === selectedFacet);
      if (currentPxScore !== selectedPxScore) {
        eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
        eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
      }
    }
    return null;
  }

  componentDidMount() {
    // We are defaulting to show the most prominent factor
    // Hence facet is unset after mounting
    const { eventEmitter } = this.props;
    eventEmitter.dispatch('facetChanged', undefined);
  }

  render() {
    const { selectedFactor, selectedFacet } = this.state;
    const {
      eventEmitter,
      objects,
      selectedIndex,
      OFacetLabels,
      OFacetSeries,
      CFacetLabels,
      CFacetSeries,
      EFacetLabels,
      EFacetSeries,
      AFacetLabels,
      AFacetSeries,
      NFacetLabels,
      NFacetSeries,
      style,
    } = this.props;
    switch (selectedFactor) {
      case 'px_dim_o': {
        return (
          <SquishlessNightingale
            title="Facets of Openness"
            labels={OFacetLabels}
            series={OFacetSeries}
            style={style}
            selected={selectedFacet}
            onClick={(code) => {
              const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
              eventEmitter.dispatch('facetChanged', code);
              eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
              eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
            }}
            showRange
            showRangeControl
          />
        );
      }
      case 'px_dim_c': {
        return (
          <SquishlessNightingale
            title="Facets of Conscientiousness"
            labels={CFacetLabels}
            series={CFacetSeries}
            style={style}
            selected={selectedFacet}
            onClick={(code) => {
              const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
              eventEmitter.dispatch('facetChanged', code);
              eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
              eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
            }}
            showRange
            showRangeControl
          />
        );
      }
      case 'px_dim_e': {
        return (
          <SquishlessNightingale
            title="Facets of Extraversion"
            labels={EFacetLabels}
            series={EFacetSeries}
            style={style}
            selected={selectedFacet}
            onClick={(code) => {
              const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
              eventEmitter.dispatch('facetChanged', code);
              eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
              eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
            }}
            showRange
            showRangeControl
          />
        );
      }
      case 'px_dim_a': {
        return (
          <SquishlessNightingale
            title="Facets of Agreeableness"
            labels={AFacetLabels}
            series={AFacetSeries}
            style={style}
            selected={selectedFacet}
            onClick={(code) => {
              const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
              eventEmitter.dispatch('facetChanged', code);
              eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
              eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
            }}
            showRange
            showRangeControl
          />
        );
      }
      case 'px_dim_n': {
        return (
          <SquishlessNightingale
            title="Facets of Neuroticism"
            labels={NFacetLabels}
            series={NFacetSeries}
            style={style}
            selected={selectedFacet}
            onClick={(code) => {
              const selectedPxScore = objects[selectedIndex].pxScores.find((pxScore) => pxScore.trait.code === code);
              eventEmitter.dispatch('facetChanged', code);
              eventEmitter.dispatch('traitChanged', selectedPxScore.trait);
              eventEmitter.dispatch('scoreChanged', selectedPxScore.score);
            }}
            showRange
            showRangeControl
          />
        );
      }
      default:
    }
    return null;
  }
}
